import { render, staticRenderFns } from "./Schedule.vue?vue&type=template&id=3dec0b04&scoped=true&"
import script from "./Schedule.vue?vue&type=script&lang=ts&"
export * from "./Schedule.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dec0b04",
  null
  
)

export default component.exports